import React, { PureComponent } from 'react';
import ItemList from '@client/containers/itemList/ItemList';
import PageLoaderWithTryAgain from '@client/components/pageLoader/PageLoaderWithTryAgain';
import { getSeries } from '@client/connectivity/api.series';
import { seriesRoute } from '@client/pages/routes';
import { strings } from '@client/localization/Localization';
import HeroSection from '@client/containers/heroSection/HeroSection';
import shapes from '@client/shared/js/shapes';
import styles from './seriesPage.scss';

class SeriesPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      seriesPageContent: undefined,
      failedToLoadContent: false,
    };
  }

  componentDidMount() {
    this.getAllSeries();
  }

  getAllSeries = () => {
    this.setState({ failedToLoadContent: false });
    getSeries()
      .then((seriesPageContent) => {
        this.setState({
          seriesPageContent: seriesPageContent.data,
        });
      })
      .catch(() => {
        this.setState({ failedToLoadContent: true });
      });
  };

  render() {
    const { seriesPageContent, failedToLoadContent } = this.state;
    if (!seriesPageContent) {
      return (
        <PageLoaderWithTryAgain
          onTryAgainClick={this.getAllSeries}
          failed={failedToLoadContent}
          tryAgain={true}
        />
      );
    }

    return (
      <div className={styles.seriesPage}>
        <HeroSection
          title={seriesPageContent.config.heroTitle}
          description={seriesPageContent.config.heroDescription}
          imageUrl={seriesPageContent.config.heroImageUrl}
          graphicsHeroMobile={shapes.graphic_header_mobile_2}
          graphicsHero={shapes.graphic_header_2}
        />
        <div className={styles.seriesPageContentContainer}>
          <ItemList
            itemOverlay={false}
            items={seriesPageContent.items}
            sectionTitle={strings.allSeries}
            getItemRoute={(item) => seriesRoute(item.slug)}
          />
        </div>
        <div className={styles.shapeTopRight}>
          <picture>
            <source media="(max-width: 768px)" srcSet={shapes.graphic_mall_2} />
            <img
              className={styles.shapeTopRight}
              src={shapes.graphic_mall_2_2x}
              alt="Factuals graphic footer"
            />
          </picture>
        </div>
      </div>
    );
  }
}

export default SeriesPage;
